<template>
    <div style="margin: 16px;">
        <p>更新日期：2021年8月27日</p>
        <p>生效日期：2021年8月24日</p>
        <p>重要提示</p>
        <p>1.1
            深圳乐漂科技（以下简称“乐漂科技”或“我们”）在此特别提醒：请您在使用我们提供的任意手机车机互联软件（以下简称为“本软件”）前，务必认真阅读本用户协议，确保您已充分理解本协议中各条款。请您在审慎阅读并充分理解的基础上，选择接受或不接受本协议。如果您不同意本协议的任意内容，或者无法理解本协议对条款的解释，请不要进行后续操作。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
        </p>
        <p>1.2
            乐漂科技保留在国家法律法规变更或产品升级等的情况下，随时修订本协议相关条款的权利，且无须事先另行通知您。相关条款一旦发生变动，乐漂科技会在本软件上通知、公布重新修订后的条款，请您注意及时查看变更后的条款。您理解并同意，如果您在本协议修订版本生效后继续使用本软件，乐漂科技将把您的使用行为视为对修订后条款的接受。如果您不能接受修订，您可以通过停止使用本软件终止本协议。
        </p>
        <p>免责声明</p>
        <p>2.1 请您在汽车行驶前或停靠时操作本软件，切勿在行驶过程中操作，否则由此造成的安全事故应由您自行承担责任。</p>
        <p>2.2 请您在注册后使用本软件，并在需要使用某些功能时开启对本软件的具体授权。我司采集的用户信息将在匿名化处理的基础上进行分析研究，用于产品改善和新功能开发。</p>
        <p>2.3 我们的软件在使用过程中可能会产生网络流量费用，例如进行在线定位、路线规划、导航、实时路况、下载离线地图、网络音乐、网络FM、车载对讲等，该费用由您互联的手机的相应网络服务提供商收取。</p>
        <p>2.4 本软件包含车机端互联软件，其适用于指定OEM车载终端或授权服务商，如果在其他的终端系统上使用该软件出现任何问题，或由于使用者使用手机端任意第三方软件进行投屏反控导致出现的任何问题，本公司不承担任何责任。</p>
        <p>2.5 我们的软件提供的任何导航功能及音乐播放、电话服务、车载对讲功能仅供您参考使用，请不要以此作为您行驶或出行的唯一依据，请您以实际的交通和道路状况为准。</p>
        <p>2.6 请您一定按照交通法规规范出行，您的任何违反交通法规和其他法律规定的行为，将由您自行承担责任。</p>
        <p>2.7 请您不要允许他人使用您装载的本软件，否则视为您已将本声明内容全部告知他人且为他人完全接受。</p>
        <p>2.8 未成年人应在法定监护人的陪同下使用本软件。未成年人不得单独使用本软件。</p>
        <p>服务介绍</p>
        <p>3.1 本软件是一款专为驾驶设计的手机-车机互联APP，支持本软件与车机互联后，实现手机屏幕和车机屏幕同步共享。您可以通过操作手机端软件，来使用我们的产品和服务。我们的软件一般包含地图/导航、音乐、电话/回拨、对讲/群聊。</p>
        <p>3.1.1地图/导航：接入天地图服务，您可以进行地图浏览、地点搜索、路线规划、导航等。</p>
        <p>3.1.2音乐：支持播放本地音乐。在线音乐播放功能接入了QQ音乐。</p>
        <p>3.1.3电话：同步用户手机通讯录，通话记录，支持语音搜索联系人拨打电话。</p>
        <p>3.1.4对讲/群聊：支持多人对讲、位置实时共享、共同目的地导航，结伴出行不掉队。</p>
        <p>3.2 账号注册</p>
        <p>本软件的部分服务需要您注册账号后才可以使用，您可以通过手机号进行注册、登陆。届时您可以根据提示进行操作。</p>
        <p>3.3 账号注销</p>
        <p>3.3.1在需要终止使用本协议服务时，符合以下条件的，您可以申请注销您的账户：</p>
        <p>（1）您仅能申请注销您本人的账户；</p>
        <p>（2）您可以通过自助或者人工的方式申请注销账户；</p>
        <p>（3）您申请注销的账户处于正常状态，即您的账户的信息是最新、完整、正确的，且账户未被采取冻结等限制措施；</p>
        <p>（4）为了维护您的合法利益，您申请注销的账户，应当不存在未了结的权利义务或其他因为注销该账户会产生纠纷的情况。</p>
        <p>3.3.2如您使用账户发生任何违反法律法规或严重违反本协议约定内容的行为，我们可以注销您的账户，并终止提供本协议服务且无须承担任何责任。</p>
        <p>3.3.3账户注销后，您仍应对您在注销账户前且使用本软件服务期间的行为承担相应责任，包括但不限于可能产生的违约责任、损害赔偿责任及履约义务，同时我们可保存您注销前的相关信息。</p>
        <p>3.3.4一旦注销成功，账户记录、账户功能等将无法恢复或提供。</p>
        <p>第三方服务</p>
        <p>为了向您提供更多样化的服务或为了统计分析等目的，本软件可能会集成第三方的SDK或其他类似的服务接口，指向或包含任何第三方所提供的网站、产品、服务或其他任何内容（统称为“第三方服务”）。第三方服务均由第三方公司或机构（统称为“第三方”）提供，我们对第三方服务及其任何内容不提供任何担保或保证。第三方在提供服务的过程中向您作出的任何承诺、保证及任何其他行为均为第三方行为，与我们无关，我们不会对第三方的服务和行为负责，且在任何情况下不会对第三方服务及其行为承担法律责任。您理解并同意，您在使用第三方服务时，应仔细阅读并遵守第三方的服务条款、隐私权政策或其他第三方要求您遵守的任何法律文件。
        </p>
        <p>使用对讲功能的特别注意事项</p>
        <p>4.1 在您使用本软件的对讲功能时，邀请方可以通过短信、口令或社交软件分享的方式向被邀请方发出进群邀请，并共享位置信息，在被邀请方通过邀请进群之后，双方即可共享彼此位置。如果邀请未经同意，我们不会将您的位置发送给任何人。</p>
        <p>4.2 您可以通过群设置方式关闭共享位置功能，否则，在本软件开启和联网状态下您和他人可以持续看到彼此位置。但为保证用户的隐私安全，所有共享关系会在您退出群房间后自动断开。</p>
        <p>4.3 是否与他人共享位置由您自行判断和自愿选择，您理解并清楚与他人进行位置共享所可能引发的一切后果，由此产生的任何责任由您自行承担。</p>
        <p>4.4 为了您的人身财产安全，请勿向陌生人发送位置共享邀请或同意陌生人的邀请。</p>
        <p>用户个人隐私信息保护</p>
        <p>5.1 您使用本软件内具体功能时，我们可能需要您同意我们获取一些您的个人信息，方可使用该功能，届时我们会单独提醒您给予授权，具体内容详见《乐漂科技隐私政策》。</p>
        <p>5.2 非个人隐私信息是指用户对本服务的操作状态以及使用习惯等明确且客观反映在我们服务器端的基本记录信息、个人隐私信息范围外的其它普通信息，以及用户同意公开的上述非隐私信息。</p>
        <p>5.3
            尊重用户个人隐私信息的私有性是我们的一贯制度，我们将采取技术措施和其他必要措施，保护您个人隐私信息安全，防止在本服务中收集的您的个人隐私信息泄露、毁损或丢失。在发生前述情形或者我们发现存在发生前述情形的可能时，将及时采取补救措施。
        </p>
        <p>5.4 未经您同意，我们不会向任何第三方公开、 透露用户个人隐私信息。但以下特定情形除外：</p>
        <p>(1) 根据法律法规规定或有关行政执法机关的指示，需要提供您的个人隐私信息的；</p>
        <p>(2) 由于您将其用户密码告知他人或与他人共享注册账户与密码，由此导致的您的个人信息的泄漏，或其他非因我们原因导致的个人隐私信息的泄露；</p>
        <p>(3) 您自行向第三方公开的个人隐私信息；</p>
        <p>(4) 您与我们、我们的关联公司或合作单位之间就用户个人隐私信息的使用公开达成约定，我们因此向关联公司或合作单位公开用户个人隐私信息；</p>
        <p>(5) 任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致的个人隐私信息的泄露。</p>
        <p>5.5 您同意我们可在以下事项中使用您的个人隐私信息：</p>
        <p>(1) 我们向您及时发送重要通知，如软件更新、本协议条款的变更；</p>
        <p>(2) 我们内部进行审计、数据分析和研究等，以改进我们的产品、服务和与用户之间的沟通，此种使用我们会先对您的个人信息作匿名化处理；</p>
        <p>(3) 适用法律法规规定的其他事项。</p>
        <p>除上述事项外，如未取得您的事先同意，我们不会将您的个人信息使用于任何其他用途。</p>
        <p>内容规范</p>
        <p>6.1
            本条所述内容规范是指您使用本软件过程中所上传、发布、传播的任何内容，包括但不限于帐号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用帐号或本服务所产生的内容。
        </p>
        <p>6.2 您不得利用本软件上传、复制、发布、传播如下法律、法规和政策禁止的内容，否则我们有权中止或终止向您提供本软件服务，并向您追究由此给我们带来的全部损失（包括但不限于直接经济损失、商誉损失、律师费）。 </p>
        <p>(1) 反对宪法所确定的基本原则的；</p>
        <p>(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p>(3) 损害国家荣誉和利益的；</p>
        <p>(4) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p>(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p>(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p>(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
        <p>(8) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
        <p>(9) 不遵守法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的；</p>
        <p>(10) 含有法律、行政法规禁止的其他内容的信息。</p>
        <p>6.3 您不得利用本软件上传、复制、发布、传播如下干扰本软件正常运营，以及侵犯其他用户或第三方合法权益的内容，否则我们有权中止或终止向您提供本软件服务，并向您追究由此给我们带来的全部损失（包括但不限于直接经济损失、商誉损失、律师费）。
        </p>
        <p>(1) 含有任何性或性暗示的； </p>
        <p>(2) 含有辱骂、恐吓、威胁内容的； </p>
        <p>(3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的； </p>
        <p>(4) 涉及他人隐私、个人信息或资料的； </p>
        <p>(5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的； </p>
        <p>(6) 含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
        <p>知识产权</p>
        <p>7.1
            我们拥有本软件的知识产权或取得了第三方的合法授权，未经我们书面允许，您不得将本软件转移、转借、复制、出租或赠与任何第三方使用或用做除本协议目的外的其他商业用途，也不得以任何理由对本软件进行破解、篡改、拆毁、反向开发、反编译等操作。
        </p>
        <p>7.2
            在使用本软件过程中，您提供、发布及在使用我们的产品和服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，均不会因上传、发布等行为发生知识产权、肖像权等权利的转移。除非我们另行说明，在法律允许的范围内，您免费授予我们及我们的关联公司非排他的、无地域限制的许可使用（包括存储、使用、复制、修订、编辑、发布、展示、翻译、分发上述信息或制作派生作品，以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内等）及可再许可第三方使用的权利，以及可以自身名义对第三方侵权行为取证及提起诉讼的权利。
        </p>
        <p>法律责任</p>
        <p>8.1
            如果我们发现或收到他人举报或投诉您违反本协议约定的，我们有权不经通知您而随时对相关内容，包括但不限于用户资料、聊天记录进行审查、删除，并视情节轻重对违规账号处以包括但不限于警告、账号封禁、设备封禁、功能封禁的处罚，且通知您处理结果。
        </p>
        <p>8.2 您理解并同意，我们有权在合理判断的前提下，对您违反有关法律法规或本协议规定的行为进行处罚或采取适当的法律措施。您应承担由此而产生的一切法律责任。</p>
        <p>8.3 您理解并同意，因您违反本协议约定，导致或产生任何第三方的任何索赔、要求或损失，包括合理的律师费，您都应当由您自行承担。我们代为承担的，有权向您追偿；您还应当承担由此给我们及我们的关联公司、合作公司带来的全部损失。</p>
        <p>其他</p>
        <p>9.1 本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若您和我们发生任何纠纷或争议，首先应友好协商解决，协商不成的，您同意将纠纷或争议提交我们注册地有管辖权的人民法院管辖。</p>
        <p>9.2 本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。</p>
        <p></p>
        <p>再次感谢您对乐漂科技的信任和使用！</p>
    </div>
</template>
<script>
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

export default {
    mounted() {
        var lang = this.$route.query.lang;
        const store = useStore();
        const i18n = useI18n();
        i18n.locale.value = lang;
        store.commit("setLanguage", lang);
        
        document.title=this.$t('msg.userManual')
    }
}
</script>
<style>
p {
    text-indent: 2em;
}</style>